import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals } from "ramda";
import { RadioFilterFieldset } from "@interdependence-ui";
import { comparators } from "utils/measurement";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox", "border"];
export default /*#__PURE__*/memo(function SelectValueComparator(props) {
  var selected = props.selected,
    selectable = props.selectable,
    onChange = props.onChange;
  var comparatorKeys = Object.keys(comparators);
  var options = comparatorKeys.filter(function (key) {
    return selectable.includes(key);
  }).map(function (key) {
    return {
      id: key,
      label: comparators[key],
      checked: selected === key
    };
  });
  return /*#__PURE__*/_jsx(RadioFilterFieldset, _objectSpread({
    id: "select-value-comparator",
    legend: "V\xE4lj vad enheternas v\xE4rden ska j\xE4mf\xF6ras mot",
    hideLegend: true,
    options: options,
    updateSelected: onChange,
    name: "target-comparator"
  }, extendedSystemStylesProps(styledSystemKeys, props)));
}, function (prev, curr) {
  return equals(prev.selected, curr.selected) && equals(prev.selectable, curr.selectable);
});